export enum UserRelation {
  ALL = 'true',
  NONE = 'false',
  COUNTRY = 'country',
  RESOURCE = 'resource',
  COMPANY = 'company',
  PRODUCTFAVORITS = 'productfavorites',
  ADDRESSES = 'addresses'
}
